<template>
    <div
        class="heartbeat-card"
        aria-hidden="true"
    >
        <div class="heartbeat-card__notif">
            <div class="heartbeat-card__row">
                <span class="heartbeat-card__app">
                    <span class="heartbeat-card__logo">🖤</span>
                    {{ copy.app }}
                </span>
                <span class="heartbeat-card__when">{{ copy.when }}</span>
            </div>
            <p class="heartbeat-card__question">{{ copy.question }}</p>
            <span class="heartbeat-card__answer">
                <span class="heartbeat-card__check">✓</span>
                {{ copy.answer }}
            </span>
        </div>
        <HeartbeatPulse class="heartbeat-card__pulse" />
        <p class="heartbeat-card__caption">{{ copy.caption }}</p>
    </div>
</template>

<script>
import { mapState } from 'pinia'
import { useStore } from '@/stores/index'
import { getFeaturesContent } from '@/data/features'
import HeartbeatPulse from '@/components/Sections/HeartbeatPulse.vue'

export default {
    name: 'HeartbeatCard',
    components: { HeartbeatPulse },
    computed: {
        ...mapState(useStore, ['language']),
        copy() {
            return getFeaturesContent(this.language).heartbeat
        },
    },
}
</script>

<style lang="scss" scoped>
.heartbeat-card {
    width: 320px;
    max-width: 100%;
    margin: 0 auto;
    padding: 36px 24px 28px;
    border-radius: 28px;
    background: var(--bzioup-color-night-soft);
    color: #fff;
    border: 1px solid rgba(255, 255, 255, 0.08);
    box-shadow: 0 24px 50px rgba(0, 0, 0, 0.35);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 22px;
}

.heartbeat-card__notif {
    width: 100%;
    box-sizing: border-box;
    padding: 14px 16px;
    border-radius: 18px;
    background: rgba(255, 255, 255, 0.96);
    color: var(--bzioup-color-Z);
    text-align: left;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
    animation: heartbeat-card-drop 900ms cubic-bezier(0.2, 0.8, 0.3, 1) both;
}

.heartbeat-card__row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    color: var(--bzioup-color-Y);
}

.heartbeat-card__app {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-weight: 700;
    color: var(--bzioup-color-Z);
}

.heartbeat-card__logo {
    font-size: 13px;
}

.heartbeat-card__question {
    margin: 10px 0 12px;
    font-size: 17px;
    font-weight: 700;
}

.heartbeat-card__answer {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 14px;
    border-radius: 999px;
    background: var(--bzioup-color-pink);
    color: #fff;
    font-size: 13px;
    font-weight: 700;
}

.heartbeat-card__check {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.25);
    font-size: 11px;
}

.heartbeat-card .heartbeat-card__pulse {
    width: 200px;
    height: 50px;
}

.heartbeat-card__caption {
    margin: 0;
    font-size: 13px;
    font-style: italic;
    opacity: 0.6;
    text-align: center;
}

@keyframes heartbeat-card-drop {
    from { opacity: 0; transform: translateY(-16px); }
    to   { opacity: 1; transform: translateY(0); }
}
</style>
